import { useLanguage } from '@/context/LanguageContext'
import { DataList, DataListOption } from '@/services/mobi-api/data/types'
import React, { FunctionComponent } from 'react'
import DataCard from './dataCard'
import classNames from 'classnames'

interface Props {
  dataList: DataList[]
  selectedGroup: number
  clickedOption?: DataListOption
  selectPackage: (item: DataListOption) => void
}

const ShowByGroup: FunctionComponent<Props> = ({ dataList, selectedGroup, clickedOption, selectPackage }) => {
  const { locale } = useLanguage()

  if (dataList === undefined) {
    return <div>404</div>
  }

  return (
    <div className='bg-surfaceMid rounded-2xl p-1 mb-40 lg:mb-24'>
      <span className='text-textHigh font-bold text-sm m-3'>
        {locale === 'en' ? dataList[selectedGroup].groupNameEn : dataList[selectedGroup].groupNameMn}
      </span>
      <div className={classNames('gap-2 mt-2', dataList[selectedGroup].cardType === 1 ? 'grid grid-cols-2' : 'flex flex-col')}>
        {dataList[selectedGroup].options.map((item, i) => (
          <DataCard key={i} item={item} clickedOption={clickedOption} selectPackage={selectPackage} cardType={dataList[selectedGroup].cardType ?? 1} />
        ))}
      </div>
    </div>

  )
}

export default ShowByGroup
